"use client";

import { useEffect } from "react";
import {
  startRegionVisibilityObserver,
  stopRegionVisibilityObserver,
} from "./region-visibility-observer";

/**
 * Drop-in client component that starts the global region visibility observer.
 * Place once in a layout or page — it will automatically track all elements
 * with `data-analytics-region` as they scroll into view.
 *
 * Renders nothing to the DOM.
 */
export function RegionVisibilityTracker() {
  useEffect(() => {
    startRegionVisibilityObserver();
    return () => stopRegionVisibilityObserver();
  }, []);

  return null;
}
